import Popup from "reactjs-popup";
import { translate } from '@app/locale/translate'
import { Text, Heading, Box, Flex, Button } from "rebass";

export const getNetworkError = (err) => {
  if (err) {
    let alertTitle = err.data.error;
    let alertMessage = err.data.error_description;
    if (!alertTitle && err.data.errors) {
      alertTitle = err.statusText;
      alertMessage = err.data.errors[0].message; // "[" + err.data.errors[0].code + "] " + err.data.errors[0].message
    }
    return {
      status: err.status,
      title: translate("Error"),
      message: alertMessage,
    };
  }
  return {
    title: translate("Error"),
    message: translate(
      "Unable to connect to the server at the moment, please check your network connection"
    ),
  };
};

const Alert = (props) => {
  return (
    <Popup
      open={props.open}
      modal={true}
      position="center center"
      closeOnDocumentClick
      closeOnEscape
      onClose={props.onClose}
      contentStyle={{
        border: "none",
        borderRadius: "5px",
        padding: "0",
        width: "100%",
        maxWidth: "720px",
        textAlign: "center",
      }}
      overlayStyle={{
        background: "rgba(0, 0, 0, 0.1)",
      }}
    >
      <Box>
        <Box
          height={48}
          px={32}
          bg="accent"
          sx={{
            borderTopLeftRadius: "5px",
            borderTopRightRadius: "5px",
            lineHeight: "48px",
          }}
        >
          <Heading
            fontSize={3}
            lineHeight="48px"
            color={"white"}
            sx={{ textTransform: "uppercase" }}
          >
            {props.title}
          </Heading>
        </Box>
        <Box p={32}>
          <Text>{props.message}</Text>
          {props.children}
          {props.actions && (
            <Flex mt={4} flexWrap="wrap" justifyContent="space-around">
              {props.actions.map((a) => {
                return (
                  <Button
                    m={2}
                    width={180}
                    key={a.title}
                    variant={a.class}
                    onClick={a.action}
                  >
                    {a.title}
                  </Button>
                );
              })}
            </Flex>
          )}
        </Box>
      </Box>
    </Popup>
  );
};

export default Alert;
